import gql from 'graphql-tag'

// Create user uses custom `accountSignup` schema extension
export const accountSignup = gql`
	mutation(
		$email: String!,
		$password: String!,
		$nameFirst: String!,
		$nameLast: String!
	) {
		accountSignup(
			email: $email
			password: $password
			nameFirst: $nameFirst
			nameLast: $nameLast
		) {
			id
		}
	}
`

// Signin user uses custom `accountAuthenticate` schema extension
export const accountAuthenticate = gql`
	mutation($email: String!, $password: String!) {
		accountAuthenticate(email: $email, password: $password) {
			token
		}
	}
`

// Uses custom 'accountDelete' schema extension
export const accountDeleteMutation = gql`
	mutation($email: String!, $password: String!) {
		accountDelete(email: $email, password: $password) {
			id
		}
	}
`

// Email confirmation uses custom 'emailConfirm' schema extension
export const emailConfirm = gql`
	mutation($accountConfirmedToken: String!) {
		emailConfirm(accountConfirmedToken: $accountConfirmedToken) {
			id
		}
	}
`

// Resend confirmation email uses custom 'emailConfirmAgain' schema extension
export const emailConfirmAgain = gql`
	mutation($email: String!) {
		emailConfirmAgain(email: $email) {
			id
		}
	}
`

// Uses custom 'emailUpdate' schema extension
export const emailUpdateMutation = gql`
	mutation($email: String!, $password: String!, $newEmail: String!) {
		emailUpdate(email: $email, password: $password, newEmail: $newEmail) {
			id
		}
	}
`

// Uses custom 'passwordUpdate' schema extension
export const passwordUpdateMutation = gql`
	mutation($email: String!, $oldPassword: String!, $newPassword: String!) {
		passwordUpdate(email: $email, password: $oldPassword, newPassword: $newPassword) {
			id
		}
	}
`

// Uses custom 'passwordResetTrigger' mutation
export const passwordResetTriggerMutation = gql`
	mutation($email: String!) {
		passwordResetTrigger(email: $email) {
			id
		}
	}
`

// Uses custom 'passwordReset' mutation
export const passwordResetMutation = gql`
	mutation($passwordResetToken: String!, $password: String!) {
		passwordReset(passwordResetToken: $passwordResetToken, password: $password) {
			id
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/account.js